import { createApp } from 'vue'
import { createPinia } from 'pinia';

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import VueParticles from 'vue-particles'

import UzhnetInput from './components/UIKit/UzhnetInput.vue'
import UzhnetInputSecondary from './components/UIKit/UzhnetInputSecondary.vue'

import UzhnetButton from './components/UIKit/UzhnetButton.vue'
import UzhnetButtonSecondary from './components/UIKit/UzhnetButtonSecondary.vue'
import UzhnetButtonDanger from './components/UIKit/UzhnetButtonDanger.vue';
import UzhnetBackButton from './components/UIKit/UzhnetBackButton.vue';

import UzhnetSelect from './components/UIKit/UzhnetSelect.vue'

import UzhnetCardDanger from './components/UIKit/UzhnetCardDanger.vue'

import UzhnetInputLine from './components/UIKit/UzhnetInputLine.vue'

import UzhnetSwitch from './components/UIKit/UzhnetSwitch.vue'

import UzhnetMultiSelect from './components/UIKit/UzhnetMultiSelect.vue'

import i18n from './i18n/locale'
import { getParentOrigin } from './services/parentOrigin'

getParentOrigin()

const app = createApp(App)
const pinia = createPinia();

app.use(pinia);

app.component('uzhnet-input', UzhnetInput)
app.component('uzhnet-input-secondary', UzhnetInputSecondary)
app.component('uzhnet-input-line', UzhnetInputLine)

app.component('uzhnet-button', UzhnetButton)
app.component('uzhnet-button-secondary', UzhnetButtonSecondary)
app.component('uzhnet-button-danger', UzhnetButtonDanger)
app.component('uzhnet-back-button', UzhnetBackButton)

app.component('uzhnet-select', UzhnetSelect)

app.component('uzhnet-card-danger', UzhnetCardDanger)

app.component('uzhnet-switch', UzhnetSwitch)

app.component('uzhnet-multi-select', UzhnetMultiSelect)

app.use(VueParticles).use(router).use(i18n).mount('#app')
